import { Navigate, useLocation } from "react-router-dom";
import React from "react";
import { useAuthContext } from "../../auth/useAuthContext";
import LoadingPage from "./LoadingPage";

/**
 * ProtectedRoute - authentication-only guard.
 * Checks if the user is authenticated. If not, redirects to /login.
 * Permission checks are handled separately by PermissionGuard.
 */
function ProtectedRoute({ children }) {
  const location = useLocation();
  const { isInitialized, isAuthenticated } = useAuthContext();

  if (!isInitialized) {
    return <LoadingPage />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
